import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  @media (max-width: 1400px) {
    width: 511px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  box-sizing: border-box;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  width: 760px;
  height: 100%;
  cursor: pointer;
  background: transparent;
  padding-left: ${(props) => (props.subRow ? "35px" : props.thirdLevel ? "72px" : "52px")};
  @media (max-width: 1400px) {
    width: 511px;
    padding-left: ${(props) => (props.subRow ? "15px" : props.thirdLevel ? "72px" : "52px")};
  }
`;

export const Description = styled.div`
  padding-left: 35px;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  font-size: 12px;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  @media (max-width: 1366px) {
    width: 390px;
  }
`;
